import React from 'react';
import FilterBySixMonths from './Components/FilterBySixMonths';
import {useFormikContext} from 'formik';
import {useTranslation} from 'react-i18next';
import {RequestPaperworkListType} from '../../types/TypesDepotPaperwork';
import FilterByStatus from './Components/FilterByStatus';
import TextFilterField from './Components/TextFilterField';
import GreenButton from '../Buttons/GreenButton';
import LightGreenButton from '../Buttons/LightGreenButton';
import FromDateToDateFilter from './Components/FromDateToDateFilter';
type Props = {
	active: boolean;
	onCancelFilter?: () => void;
};
const PaperWorkFilter: React.FC<Props> = ({active, onCancelFilter}) => {
	const {t} = useTranslation();
	const {values, setFieldValue, touched, errors, resetForm} =
		useFormikContext<RequestPaperworkListType>();
	const statusOptions = [
		{
			value: 'null',
			label: t('Всі'),
		},
		{
			value: 'created',
			label: t('Чернетка'),
		},
		{
			value: 'confirmed',
			label: t('Нові'),
		},
		{
			value: 'approved',
			label: t('Підтверджено'),
		},
	];
	return (
		<div
			className={`filter-team__filter-item item-filter ${!active ? '' : 'active'}`}
		>
			<div className="item-filter__wrapper">
				<div className="item-filter__form form-filter">
					<FilterBySixMonths setFieldValue={setFieldValue} />
					<FilterByStatus
						fieldName={'status_delivery'}
						statusOptions={statusOptions}
						label={t('Статус доставки')}
						value={values.status_delivery ?? ''}
					/>
					<TextFilterField
						label={t('За товаром')}
						fieldName={'product_name'}
						placeholder={t('Комплекс Омега')}
						value={values.product_name ?? ''}
					/>
					<TextFilterField
						label={t('За номером')}
						fieldName={'order_id'}
						placeholder={t('123456789')}
						value={values.order_id ?? ''}
						touched={touched.order_id !== undefined}
						error={errors.order_id !== undefined}
					/>
					<FromDateToDateFilter
						byDateFieldName={'from_date'}
						toDateFieldName={'to_date'}
					/>

					<TextFilterField
						label={t('По клієнту')}
						fieldName={'client_name'}
						placeholder={t('380123456789')}
						value={values.client_name ?? ''}
						touched={touched.client_name !== undefined}
						error={errors.client_name !== undefined}
					/>
					<div className="item-filter__buttons">
						<LightGreenButton text={t('застосувати')} type={'submit'} />
						<GreenButton
							text={t('скасувати фільтр')}
							type={'button'}
							onClick={() => {
								resetForm();
								setFieldValue('filter_active', false);
								onCancelFilter && onCancelFilter();
							}}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PaperWorkFilter;
